import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./videoPreviewV2.html";
class VideoPreviewV2 extends LightningElement {
  constructor(...args) {
    super(...args);
    this.positionIndex = void 0;
    this.posterSrc = '';
    this.altText = '';
  }
  handleAnalytics(event) {
    event.detail.image = {
      positionIndex: this.positionIndex
    };
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(VideoPreviewV2, {
  publicProps: {
    positionIndex: {
      config: 0
    },
    posterSrc: {
      config: 0
    },
    altText: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(VideoPreviewV2, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;